import { useTranslation as useTranslation$1 } from 'react-i18next';
import useGlobalTranslation from './useGlobalTranslation.js';

function useTranslation(namespace, fallback, keys) {
    const globalTranslation = useGlobalTranslation();
    if (!!globalTranslation) {
        return globalTranslation(namespace, keys);
    }
    else {
        const fallbackLng = 'en';
        const response = useTranslation$1(namespace, { useSuspense: true });
        if (response.ready && !response.i18n.hasResourceBundle(fallbackLng, namespace)) {
            response.i18n.addResourceBundle(fallbackLng, namespace, fallback, true, true);
        }
        return response;
    }
}

export { useTranslation as default };
//# sourceMappingURL=useTranslation.js.map
